import axiosAdmin from "api/axiosAdmin";
import { useState } from "react";
import { toast } from "react-toastify";

const InviteTokenPage = () => {
  const [inviteToken, setInviteToken] = useState("");

  const generateInviteToken = async () => {
    try {
      const response = await axiosAdmin.post("/invite-token/create");

      setInviteToken(response.data);
      toast.success("Invite token generated successfully");
    } catch (error) {
      console.error("Error generating invite token", error);
      toast.error("Failed to generate invite token");
    }
  };

  const copyToClipboard = () => {
    if (!inviteToken) return;

    navigator.clipboard.writeText(inviteToken).then(() => {
      toast.success("Invite token copied to clipboard");
    });
  };

  return (
    <div className="p-4 bg-white shadow-md rounded-lg">
      <h2 className="text-lg font-bold mb-4">Generate Invite Link</h2>
      <div className="flex items-center space-x-2">
        <input
          type="text"
          value={inviteToken}
          readOnly
          className="border p-2 rounded w-full"
          placeholder="Click 'Generate' to get a link"
        />
        <button
          onClick={copyToClipboard}
          disabled={!inviteToken}
          className={`px-4 py-2 rounded ${
            inviteToken ? "bg-blue-500 text-white" : "bg-gray-300 text-gray-600"
          }`}
        >
          Copy
        </button>
      </div>
      <button
        onClick={generateInviteToken}
        className="mt-4 px-4 py-2 bg-green-500 text-white rounded"
      >
        Generate
      </button>
    </div>
  );
};

export default InviteTokenPage;
